
const initialState={
    stepPortalWeb: 0,
    rechazarSolicitudPortalWeb: false,
    datosPortalWeb:{},
    cuiDPISolicitudPortalWeb:'',
    residenciaPadron: '',
};

const reducer = (state = initialState, action )=>{
    switch(action.type){
        case "SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB":
            var solicitudEmpadronamientoStepState = Object.assign({}, state);
            solicitudEmpadronamientoStepState.stepPortalWeb=action.state.stepPortalWeb;
            return solicitudEmpadronamientoStepState;  
        case "SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PORTAL_WEB":
            var solicitudEmpadronamientoRechazarSolicitudState = Object.assign({}, state);
            solicitudEmpadronamientoRechazarSolicitudState.rechazarSolicitudPortalWeb= action.state.rechazarSolicitudPortalWeb;
            return solicitudEmpadronamientoRechazarSolicitudState;                                                                             
        case "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB":
            var solicitudEmpadronamientoDatosPortalWebState = Object.assign({}, state);
            solicitudEmpadronamientoDatosPortalWebState.datosPortalWeb= action.state.datosPortalWeb;
            return solicitudEmpadronamientoDatosPortalWebState;                                                                             
        case "SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB":
            var solicitudEmpadronamientoCuiDPIPortalWebState = Object.assign({}, state);
            solicitudEmpadronamientoCuiDPIPortalWebState.cuiDPISolicitudPortalWeb= action.state.cuiDPISolicitudPortalWeb;
            return solicitudEmpadronamientoCuiDPIPortalWebState;                                                                             
        case "SET_RESIDENCIA_ACTUAL_PADRON":
            var setDataResidenciaElectoralActualEnElPadron = Object.assign({}, state);
            setDataResidenciaElectoralActualEnElPadron.residenciaPadron= action.state;
            return setDataResidenciaElectoralActualEnElPadron;                                                                             
        default:
            return state;
    }
}

export default reducer;